module.exports = __webpack_public_path__ + "img/base_activites_grands_evenements.cf6326c6.svg";